import { Outlet, Route, Routes } from "react-router-dom";
import { RequireToken } from "./components/RequireToken";
import { TabBar } from "./components/TabBar";
import { Login } from "./routes/Login";
import { Dashboard } from "./routes/Dashboard";
import { Gradient } from "./routes/Gradient";
import { Runs } from "./routes/Runs";
import { System } from "./routes/System";
import { Settings } from "./routes/Placeholder";
import "./App.css";

// The authenticated shell: scrollable content + fixed bottom tab bar.
// NOTE: no auto-navigation on new runs — every open tab stays on whatever page it's on. (A newly
// launched run just appears in the run list; select it manually.) A prior "auto-switch to the newest
// run" hook was removed because it yanked EVERY tab (incl. a second monitor on System) to the dashboard.
function Shell() {
  return (
    <div className="shell">
      <div className="shell-content">
        <Outlet />
      </div>
      <TabBar />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireToken>
            <Shell />
          </RequireToken>
        }
      >
        {/* Login lands on the Evolution Console dashboard; runs are launched
            out-of-band (orchestrator API / Claude Code), not from a form. */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/runs/:name" element={<Dashboard />} />
        {/* Not a permanent tab — surfaced via the dashboard banner when a gradient
            run is live, plus this direct URL. Guarded like the others by RequireToken. */}
        <Route path="/gradient" element={<Gradient />} />
        <Route path="/manage" element={<Runs />} />
        <Route path="/system" element={<System />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
